<template>
  <div class="page-project-edit">
    <vs-alert
      color="danger"
      title="Projekt nicht gefunden"
      :active.sync="fetchFailed"
    >
      <span>Projekt mit ID: {{ $route.params.id }} nicht gefunden.</span>
      <span>
        <span> Gehe zu </span
        ><router-link
          :to="{ name: 'job.overview' }"
          class="text-inherit underline"
          >Alle Stellenangebote</router-link
        >
      </span>
    </vs-alert>
    <vx-card v-if="vacancyProject" class="mb-6">
      <div class="vx-row">
        <div class="vx-col w-full">
          <button class="goBack-btn" @click="goBack">
            <i class="fal fa-arrow-left"></i>Zurück
          </button>
        </div>
      </div>
    </vx-card>
    <vx-card v-if="vacancyProject">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="currentTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Stammdaten" icon-pack="fad" icon="fa-home">
            <div v-if="tabs[currentTab] === 'data'" class="tab-text">
              <div class="vx-row">
                <div class="vx-col">
                  Projektnummer: {{ vacancyProject.number }}
                </div>
              </div>
              <ProjectEditGeneral
                :project-id="vacancyProject.id"
                @saved="formSaved"
              />
            </div>
          </vs-tab>
          <vs-tab label="Stellenangebote" icon-pack="fal" icon="fa-file-alt">
            <div v-if="tabs[currentTab] === 'jobs'" class="tab-text">
              <div class="jobs-overview edit-page flex flex-wrap flex-row">
                <div class="job-titles edit-titles w-full md:w-1/3 md:pr-8">
                  <JobOverview :project-id="vacancyProject.id" />
                </div>
                <div class="job-edit edit-area w-full md:w-2/3 md:pl-4">
                  <JobEdit
                    v-if="$route.params.jobid"
                    :project-id="vacancyProject.id"
                    :project-consultant-i-d="vacancyProject.consultant.id"
                    @saved="formSaved"
                  />
                </div>
              </div>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
      <div v-if="lastSave" class="text-right last-saved pl-5 pr-5">
        <vs-icon class="text-success" icon="fa-check-circle" icon-pack="far" />
        Zuletzt gespeichert: {{ $d(lastSave, "long-secounds") }}
      </div>
    </vx-card>
  </div>
</template>

<script>
import gql from "graphql-tag";
import ProjectEditGeneral from "./ProjectEditGeneral";
import JobEdit from "./JobEdit";
import JobOverview from "./JobOverview";

export default {
  components: {
    ProjectEditGeneral,
    JobOverview,
    JobEdit
  },
  data() {
    return {
      lastSave: new Date(),
      fetchFailed: false,
      currentTab: 0,
      tabs: ["data", "jobs"]
    };
  },
  apollo: {
    vacancyProject: {
      query: gql`
        query VacancyProject($id: ID!) {
          vacancyProject(id: $id) {
            id
            number
            consultant {
              id
            }
          }
        }
      `,
      variables() {
        return {
          id: this.$route.params.id
        };
      },
      error(error) {
        if (error.gqlError.message === "record not found") {
          this.fetchFailed = true;
        } else {
          this.fetchFailed = true;
          // TODO: Display different error message
        }
      }
    }
  },
  watch: {
    currentTab(tab) {
      if (this.$route.params.page !== this.tabs[tab]) {
        this.$router.replace({
          name: "project.edit.sub",
          params: { page: this.tabs[tab] }
        });
      }
    }
  },
  mounted() {
    if (this.$route.params.page) {
      this.currentTab = this.tabs.indexOf(this.$route.params.page);
    }
  },
  methods: {
    goBack() {
      return this.$router.go(-1);
    },
    formSaved(e) {
      this.$vs.notify({
        title: "Gespeichert",
        text: "Eingabe wurde erfolgreich gespeichert",
        color: "success",
        icon: "query_builder",
        position: "bottom-center"
      });
      this.lastSave = e;
    }
  }
};
</script>
